/* eslint-disable jsx-a11y/anchor-has-content,react/no-unused-prop-types */
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import connect from 'react-redux/es/connect/connect';

import {
  selectRequestState,
  sendRequest
} from 'mt-react-common/modules/tasks/common/reducers/execConfirmForm';

import OpacityPreLoader from '../../../Common/PreLoaders/OpacityPreLoader';
import InfoMaterialContent from '../../../InfoMaterials/InfoMaterialContent';

// eslint-disable-next-line react/prefer-stateless-function
class TasksExecConfirmForm extends Component {
  componentDidUpdate(prevProp) {
    if (
      prevProp.requestState.hasSuccessQuery !==
        this.props.requestState.hasSuccessQuery &&
      this.props.requestState.hasSuccessQuery
    ) {
      this.props.closeAllTabs();
    }
  }
  render() {
    return (
      <React.Fragment>
        <div className="tab-pane active" id="tabAccept51">
          <div className="panel-footer pos-rel">
            {this.props.requestState.hasInProgress ? (
              <OpacityPreLoader />
            ) : null}
            <div
              className="alert alert-success text-center m-b-15"
              role="alert"
            >
              <InfoMaterialContent id={'exec_confirm'} />
            </div>
            <a
              className="btn btn-success btn-block"
              type="button"
              href=""
              onClick={e => {
                e.preventDefault();
                this.props.sendRequest();
              }}
            >
              Принять работу и оплатить
            </a>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

TasksExecConfirmForm.propTypes = {
  // IN
  closeAllTabs: PropTypes.func.isRequired,
  exec: PropTypes.shape({
    id: PropTypes.number.isRequired
  }).isRequired,

  // CONNECT
  requestState: PropTypes.shape({
    hasInProgress: PropTypes.bool.isRequired,
    hasSuccessQuery: PropTypes.bool
  }).isRequired,
  sendRequest: PropTypes.func.isRequired
};

const mapStateToProps = (state, props) => ({
  requestState: selectRequestState(state, props.formReduceName)
});

const mapDispatchToProps = (dispatch, props) => ({
  sendRequest: () => dispatch(sendRequest(props.formReduceName, props.exec.id))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(TasksExecConfirmForm)
);



// WEBPACK FOOTER //
// ./src/components/Tasks/TasksExecsForms/TasksExecConfirmForm/TasksExecConfirmForm.js